/* @flow */
import CurrentUser from 'auth/CurrentUser';
import GroupStore from 'groups/stores/GroupStore';
import Message from 'entities/Message';
import { ChatBaseMessage, ChatMessage } from 'entities/ChatMessage';

function isAnnouncementToOwnedGroup(message: Message) {
  const threadGroupIds =
    message.getThreads().map(
      // $FlowFixMe no guarantee this thread has `group_id` attr
      thread => thread.group_id
    ) || [];
  const messageGroupIds = message.getGroupIds() || [];
  return threadGroupIds
    .concat(messageGroupIds)
    .map(id => id && GroupStore.getGroup(id))
    .map(group => group && group.isOwnedByUser(CurrentUser.getUser().id))
    .includes(true);
}

export function canViewDeliverySummary(message: Message | ChatBaseMessage): boolean {
  if (message instanceof Message) {
    return isAnnouncementToOwnedGroup(message);
  }
  if (message instanceof ChatMessage) {
    return !!message.getReadSummary();
  }
  // not applicable to the message type (e.g. PhoneCallMessage)
  return false;
}
